module.exports = __webpack_public_path__ + "static/media/nag5.701448b9.png";